import React, { useState, useEffect, useCallback } from 'react';
import PostCard from './PostCard';
import { listPosts } from '../api/community';

// Lists posts for a category with cursor-based pagination.
// Loads first page on mount + when category changes. "더 보기" appends next page.

export default function PostList({ category }) {
  const [posts, setPosts] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  const loadFirstPage = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const data = await listPosts({ category });
      setPosts(data.posts || []);
      setCursor(data.nextCursor);
      setHasMore(!!data.nextCursor);
    } catch (err) {
      console.error('[PostList] load error', err);
      setError(err.message || '목록을 불러올 수 없습니다');
    }
    setLoading(false);
  }, [category]);

  const loadMore = async () => {
    if (!cursor || loading) return;
    setLoading(true); setError(null);
    try {
      const data = await listPosts({ category, cursor });
      setPosts(prev => [...prev, ...(data.posts || [])]);
      setCursor(data.nextCursor);
      setHasMore(!!data.nextCursor);
    } catch (err) {
      console.error('[PostList] loadMore error', err);
      setError(err.message || '추가 목록을 불러올 수 없습니다');
    }
    setLoading(false);
  };

  useEffect(() => { loadFirstPage(); }, [loadFirstPage]);

  if (loading && posts.length === 0) {
    return <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 40 }}>로딩 중...</p>;
  }

  if (error && posts.length === 0) {
    return (
      <div style={{
        padding: 20, borderRadius: 'var(--radius)',
        background: 'rgba(255, 82, 82, 0.08)', border: '1px solid #ff5252',
      }}>
        <p style={{ color: '#ff5252', fontWeight: 700, marginBottom: 8 }}>❌ {error}</p>
        <button className="btn btn-outline" onClick={loadFirstPage}
          style={{ fontSize: '0.85rem', padding: '6px 14px' }}>
          다시 시도
        </button>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 40 }}>
        아직 작성된 글이 없습니다.
      </p>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {posts.map(p => <PostCard key={p.postId} post={p} />)}
      </div>
      {hasMore && (
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button
            className="btn btn-outline"
            disabled={loading}
            onClick={loadMore}
            style={{ padding: '10px 24px', fontSize: '0.9rem' }}
          >
            {loading ? '불러오는 중...' : '더 보기'}
          </button>
        </div>
      )}
      {error && posts.length > 0 && (
        <p style={{ color: '#ff5252', textAlign: 'center', marginTop: 12, fontSize: '0.85rem' }}>{error}</p>
      )}
    </div>
  );
}
